import searchLogoDark from "@assets/header/newIcons/search-mobile.svg";
import searchExpandedLogo from "@assets/search-expanded.svg";
import searchLogo from "@assets/search-new.svg";
import styles from "@components/Modules/HeaderNew/Search/Search.module.css";
import cx from "classnames";

type SearchButtonProps = {
  expanded: boolean;
  onClick: () => void;
  isMobile?: boolean;
  variant?: "dark" | "light" | "blue";
};

export function SearchButton({
  expanded,
  onClick,
  isMobile,
  variant = "light",
}: SearchButtonProps) {
  const SearchIcon =
    variant === "dark"
      ? searchLogoDark
      : variant === "blue"
        ? searchExpandedLogo
        : searchLogo;
  return (
    <>
      {expanded ? (
        <button
          data-testid="searchClose"
          className={cx(
            styles.searchCloseButton,
            {
              [styles.isMobile]: isMobile,
            },
            { "!w-[42px]": variant === "dark" },
          )}
          onClick={onClick}
        >
          <img
            src={searchExpandedLogo}
            alt="search-expanded"
            width={24}
            height={24}
          />
        </button>
      ) : (
        <button
          data-testid="searchButton"
          className={cx(
            styles.searchButton,
            { [styles.isMobile]: isMobile },
            { "!w-[42px]": variant === "dark" },
          )}
          onClick={onClick}
        >
          <img src={SearchIcon} alt="search-logo" width="24" height="24" />
        </button>
      )}
    </>
  );
}
